import React from 'react';
interface MetaLabelProps {
  children: React.ReactNode;
  tone?: 'bright' | 'muted' | 'dim';
  as?: 'span' | 'div' | 'h2' | 'h3';
  className?: string;
}
const tones = {
  bright: 'text-fg',
  muted: 'text-muted',
  dim: 'text-dim'
} as const;
export function MetaLabel({
  children,
  tone = 'muted',
  as = 'span',
  className = ''
}: MetaLabelProps) {
  const Tag = as;
  return <Tag className={`text-[10px] font-medium uppercase tracking-label ${tones[tone]} ${className}`} data-id="element-46" data-mp="2tn7dq4knelos">
      {children}
    </Tag>;
}